import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { clearQuestionNumber } from '@/store/lms/actions';

import { selectLMS } from '@/store/lms/selectors';

import { Button, Modal } from 'antd';

import Poll from '../Poll/Poll';
import { CurrentResultStatus } from './CurrentResultStatus';
import { TestDetailsActions } from './TestDetailsActions';
import { TestDetailsAnswersList } from './TestDetailsAnswersList';
import { TestDetailsInfo } from './TestDetailsInfo';
import { BlockStatus } from './types';

import css from '../Details/Details.module.scss';

import { FINISHED } from '@/constants/study-plan-statuses';

export const BlockStudyResultScreen = ({ data, block, setFinished, repeatTest, haveATimer, canRestartBlocks }) => {
  const { t } = useTranslation('details');
  const dispatch = useDispatch();
  const { statistic } = useSelector(selectLMS);
  const [modal, contextHolder] = Modal.useModal();

  const next = statistic?.blocksStat && statistic.blocksStat.filter(item => item.status !== FINISHED).length;

  const retryTestClick = () => {
    const retryTest = () => {
      repeatTest(haveATimer() ? true : block.blockId);
      dispatch(clearQuestionNumber());
    };

    // Если это предпоследняя попытка, то мы уведомляем пользователя
    if (block.test.numberTry + 1 >= block.test.allowedCountTry) {
      modal.confirm({
        title: t('continueTest'),
        content: t('lastTry'),
        onOk: retryTest,
        okText: t('continue'),
      });
    } else {
      retryTest();
    }
  };

  const actionsTestButtons = () => {
    if (!data) return;
    const buttons = [];

    const notStartedTest = data.status === BlockStatus.NOT_STARTED && !data.resultTest.review && !data.resultTest.poll;

    const isPassed = data.resultTest.countCorrectUserAnswers >= data.resultTest.pass;

    // Вернулись к старой логике по причине KAM-9751
    // const showNextBtn = notStartedTest && (isPassed || (!isPassed && !block.isAvailableForReStart));
    const showNextBtn = notStartedTest && isPassed;

    const showRetryBtn = (data.status !== BlockStatus.WAITING && block.isAvailableForReStart) || canRestartBlocks;

    if (data.status === BlockStatus.NOT_STARTED && data.resultTest.review && !data.resultTest.poll) {
      buttons.push(
        <Button
          className={css['Details-button']}
          onClick={() => setFinished(data.blockId)}
          key={'send_to_rewiev'}
          type='primary'
          size='large'
          data-qa='testDetailsActionsSendToRewiev'
        >
          {t('send_to_rewiev')}
        </Button>
      );
    }

    if (showNextBtn) {
      buttons.push(
        <Button
          data-qa='testDetailsActionsNext'
          className={css['Details-button']}
          onClick={() => setFinished(data.blockId)}
          key={'next'}
          type='primary'
          size='large'
        >
          {next > 1 ? t('next') : t('finish')}
        </Button>
      );
    }
    if (showRetryBtn) {
      buttons.push(
        <Button
          data-qa='testDetailsActionsRetry'
          className={css['Details-button']}
          onClick={retryTestClick}
          key={'retryTest'}
          type='primary'
          size='large'
        >
          {t('retryTest')}
        </Button>
      );
    }
    return buttons;
  };

  if (!data) {
    return <>Empty</>;
  }

  const currentResultStat = <CurrentResultStatus detailsTest={data} />;

  return (
    <div className={css.Details}>
      {contextHolder}
      <TestDetailsInfo testData={data} block={block} currentResultStat={currentResultStat} />
      <TestDetailsActions actionsTestButtons={actionsTestButtons()} />
      {!data.resultTest.poll && data.resultTest.extendedResults ? (
        <TestDetailsAnswersList questionAnswerList={data.resultTest.questions} />
      ) : (
        ''
      )}
      {data.resultTest.poll ? <Poll setFinished={setFinished} data={data} /> : ''}
    </div>
  );
};
